import { createTheme, Theme } from '@material-ui/core/styles';
import { Tokens } from '../tokens';

export function buildMuiTheme(tokens: Tokens): Theme {
  const { colors, typography, radii } = tokens;
  return createTheme({
    palette: {
      type: tokens.mode,
      primary: {
        main: colors.accent,
        light: colors.accentHover,
        dark: colors.accentActive,
        contrastText: colors.textInverse,
      },
      secondary: {
        main: colors.text,
        contrastText: colors.bg,
      },
      error: { main: colors.danger, contrastText: colors.textInverse },
      warning: { main: colors.warning, contrastText: colors.textInverse },
      info: { main: colors.info, contrastText: colors.textInverse },
      success: { main: colors.success, contrastText: colors.textInverse },
      background: {
        default: colors.bg,
        paper: colors.surface,
      },
      text: {
        primary: colors.text,
        secondary: colors.textSecondary,
        disabled: colors.textTertiary,
        hint: colors.textTertiary,
      },
      divider: colors.border,
    },
    typography: {
      fontFamily: typography.fontFamilySans,
      fontSize: 14,
      h1: { fontFamily: typography.fontFamilyDisplay, fontSize: typography.size['5xl'], fontWeight: typography.weight.semibold, lineHeight: typography.lineHeight.tight },
      h2: { fontFamily: typography.fontFamilyDisplay, fontSize: typography.size['4xl'], fontWeight: typography.weight.semibold, lineHeight: typography.lineHeight.tight },
      h3: { fontFamily: typography.fontFamilyDisplay, fontSize: typography.size['3xl'], fontWeight: typography.weight.semibold, lineHeight: typography.lineHeight.snug },
      h4: { fontFamily: typography.fontFamilyDisplay, fontSize: typography.size['2xl'], fontWeight: typography.weight.semibold, lineHeight: typography.lineHeight.snug },
      h5: { fontFamily: typography.fontFamilySans, fontSize: typography.size.xl, fontWeight: typography.weight.semibold, lineHeight: typography.lineHeight.snug },
      h6: { fontFamily: typography.fontFamilySans, fontSize: typography.size.lg, fontWeight: typography.weight.semibold, lineHeight: typography.lineHeight.snug },
      body1: { fontSize: typography.size.base, lineHeight: typography.lineHeight.normal },
      body2: { fontSize: typography.size.sm, lineHeight: typography.lineHeight.normal },
      button: { fontSize: typography.size.base, fontWeight: typography.weight.semibold, textTransform: 'none' },
      caption: { fontSize: typography.size.xs, lineHeight: typography.lineHeight.snug },
      overline: { fontSize: typography.size.xs, letterSpacing: typography.letterSpacing.wide, textTransform: 'uppercase' },
    },
    shape: {
      borderRadius: parseInt(radii.md, 10),
    },
  });
}
